// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import DatePicker from 'react-datepicker';
  import moment from 'moment';
  import styled from 'styled-components'
  import FlatButton from 'material-ui/FlatButton';
  import Dialog from 'material-ui/Dialog'
  import { Spinner } from 'react-activity';
  import 'react-activity/dist/react-activity.css';
  import ReactTable from "react-table"; 
  
  
  class CriticalBatches extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        venue:props.props.statsTable.revenue_per_month.requested_venue_id,
        batches:[],
        activity_state:true,
        batch_click:false,
        customer_count:0,
        last_seven_customers_count:0,
        month_customers_count:0,

      }
      this.onBatchClick = this.onBatchClick.bind(this);
  
    }
  
    componentDidMount(){
        this.getCriticalBatch()
        console.log("componentDidMount")
    }

    onBatchClick(batch_id){
        const batch = this.state.batches.find(batch=> batch.id == batch_id)
        this.setState({activity_state:true,batch:batch})
        this.getCustomerGroup(batch_id)
    }

    locationChanged() {
      this.setState({venue:this.props.props.statsTable.revenue_per_month.requested_venue_id}, () => {
        this.getCriticalBatch()
      })
    }

    getCustomerGroup(batch_id){
        const url = `${getLocationOrigin()}/cm/get_suggested_groups_for_critical_batch/?session_id=${batch_id}`;
        const options = {...defaultOptions};

        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            this.setState({batch_click:true,activity_state:false,day_code:data.day_code,month_code:data.month_code,week_code:data.week_code,customer_count:data.customer_count,last_seven_customers_count:data.last_seven_customers_count,month_customers_count:data.month_customers_count});
        }).catch(error => error);
    }

    getCriticalBatch(){
        const url = `${getLocationOrigin()}/cm/get_critical_batches/?venue_id=${this.state.venue}`;
        const options = {...defaultOptions};

        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            this.setState({batches:data.critical_sessions,activity_state:false});
        }).catch(error => error);
    }

    getTrProps = (state, rowInfo, instance) => {
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    }
    
  
    render() {

        if(this.state.venue != this.props.props.statsTable.revenue_per_month.requested_venue_id){
          this.locationChanged()
        }

        const dialog_actions = [
            <FlatButton
              label="--"
              primary={true}
              onClick={this.handleClose}
            />,
            <FlatButton
              label="--"
              primary={true}
              onClick={this.postActivityStatus}
            />,
          ];

      const columns = [{  
       Header: 'Venue',  
       accessor: 'venue'  
       },{  
       Header: 'Day',  
       accessor: 'day',
       },{  
       Header: 'Date',  
       accessor: 'date'  
       },{  
       Header: 'Type',  
       accessor: 'type',
       },{  
       Header: 'Time',  
       accessor: 'start_time',
       Cell: cellInfo  => (<span>{cellInfo.original.start_time} - {cellInfo.original.end_time}</span>),
       minWidth: 100
       },
       {  
       Header: 'Batch Size',  
       accessor: 'batch_size'
       },
       {
       Header: 'Voted In',
       accessor: 'voted_in'
       },
       {
        Header: 'Action',
        accessor: 'id',
        Cell: ({ row }) => (<button className='button1' onClick={()=>{this.onBatchClick(row.id)}}>Notify</button>)
        }
       ];
            
      return(
        <div style={styles.container}>
            { this.state.batch_click && 
              <div className="col col-md-12" style={styles.card}>
                <div className="col-md-12" style={styles.booking}>Notification</div>

                <div className="row col-md-12" style={styles.card_header}>  
                    <span className='col-md-4' style={styles.card_contents}>Group 1 (Prev Week)</span>
                    <span className='col-md-4' style={styles.card_contents}>Group 2 (Last Seven Days)</span>
                    <span className='col-md-4' style={styles.card_contents}>Group 3 (Last One month)</span>                  
                </div>
                
                <div style={styles.cart_rows} className="row col-md-12">
                    <hr/>
                    <span className='col col-md-4' style={styles.card_contents}>{this.state.customer_count}</span>
                    <span className='col col-md-4' style={styles.card_contents}>{this.state.last_seven_customers_count}</span>
                    <span className='col col-md-4' style={styles.card_contents}>{this.state.month_customers_count}</span>
                    <hr/>
                </div>

                <div style={styles.cart_rows} className="row col-md-12">
                    <hr/>
                    <span className='col col-md-4' style={styles.card_contents}> <input type="button" value="Notify" style={{'backgroundColor':"#32B6A7",'fontSize':"18px"}}  onClick={()=>{this.onNotifyClick(this.state.day_code)}} /></span>
                    <span className='col col-md-4' style={styles.card_contents}> <input type="button" value="Notify" style={{'backgroundColor':"#32B6A7",'fontSize':"18px"}}  onClick={()=>{this.onNotifyClick(this.state.week_code)}} /></span>
                    <span className='col col-md-4' style={styles.card_contents}> <input type="button" value="Notify" style={{'backgroundColor':"#32B6A7",'fontSize':"18px"}}  onClick={()=>{this.onNotifyClick(this.state.month_code)}} /></span>
                    <hr/>
                </div>
                
              </div>
            }

            <ReactTable  
            data={this.state.batches}  
            className="-striped -highlight"
            columns={columns}  
            defaultPageSize = {100}  
            pageSizeOptions = {[100,200,500]} 
            getTrProps={this.getTrProps} 
            filterable={true}
            showPagination={this.state.batches.length > 100}
            showPaginationTop = {this.state.batches.length > 100}
            style = {{background:'#9370DB'}}
            defaultFilterMethod = {(filter, row, column) => {
              const id = filter.pivotId || filter.id
              return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
            }}
            > 

            {
              //To show the record count on top  
              (state, makeTable, instance) => {

                let recordsInfoText = "";

                const { filtered, pageRows, pageSize, sortedData, page } = state;

                if (sortedData && sortedData.length > 0) {
                  let isFiltered = filtered.length > 0;

                  let totalRecords = sortedData.length;

                  let recordsCountFrom = page * pageSize + 1;

                  let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                  if (isFiltered){
                    recordsInfoText = `${totalRecords} filtered records`;
                  }
                  else {
                    recordsInfoText = `${totalRecords} records`;
                  }
                } else {
                    recordsInfoText = "No records";
                  }
                return (
                  <div className="main-grid">
                    <div className="above-table text-right">
                      <div className="col-sm-12 records-info">
                        <span className="">{recordsInfoText}</span>
                      </div>
                    </div>
                    {makeTable()}
                    
                  </div>

                );
              }
            }
          </ReactTable>
            
        </div>
      );
    }
  }
  
  export default CriticalBatches;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/CriticalBatches/index.js